<h3 class="ui primary header">{{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">

  <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
  <div class="scroll-wrapper" appMargin marginT="20px">
    <form class="ui form" [ngClass]="{'loading':pending}" [formGroup]="uploadForm">
      <div class="field" [ngClass]="displayFieldCss('documentTypeName')">
        <label class="required">Name</label>
        <input type="text" formControlName="documentTypeName" placeholder="Name" />
        <app-field-error-display [displayError]="isFieldValid('documentTypeName')" errorMsg="Please enter name">
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('isRequired')">
        <sui-checkbox formControlName="isRequired">
          Required
        </sui-checkbox>
        <app-field-error-display [displayError]="isFieldValid('isRequired')" errorMsg="Please enter name">
        </app-field-error-display>
      </div>

    </form>
  </div>
</div>
<div class="actions">
  <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">Cancel</button>
    <button class="ui primary button" [ngClass]="{'yellow loading':pending}" [disabled]="!uploadForm.valid"
      (click)="submit()" autofocus>Okay</button>
  </div>
</div>
